"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildHookContext = void 0;
var tslib_1 = require("tslib");
/**
 * Utility method for building a consistent plugin hook context, including
 * any baked in mandatory fields such as `hookName`.
 */
var buildHookContext = function (hookName, startingContext) {
  var _a = startingContext || {},
    appData = _a.appData,
    rest = tslib_1.__rest(_a, ["appData"]);
  return tslib_1.__assign(tslib_1.__assign({}, rest), {
    get hookName() {
      return hookName;
    }
  });
};
exports.buildHookContext = buildHookContext;